import {
  UserContentCopiedText,
  UserContentHighlight,
  UserContentNote,
} from 'types';

/**
 * @method findInlineUserContent
 */
const findInlineUserContent = (frameDocument, objectOrUUID) => {
  let type;
  let uuid = objectOrUUID;

  if (objectOrUUID instanceof UserContentHighlight) {
    type = 'highlight';
    uuid = objectOrUUID.uuid;
  }

  if (objectOrUUID instanceof UserContentNote) {
    type = 'note';
    uuid = objectOrUUID.uuid;
  }

  if (objectOrUUID instanceof UserContentCopiedText) {
    type = 'copied-text';
    uuid = objectOrUUID.uuid;
  }

  // If type is set, perform a type check using the button display class.
  const displayClass = `.rs-inline-display${type ? '-' + type : ''}`;
  const buttonClass = `.rs-inline-button${type ? '-' + type : ''}`;

  const highlightElement = frameDocument.body.parentElement.querySelector(
    `${displayClass}[data-rs-uuid="${uuid}"]`,
  );
  const buttonElement = frameDocument.body.parentElement.querySelector(
    `${buttonClass}[data-rs-uuid="${uuid}"]`,
  );
  const spanStartElement = frameDocument.body.parentElement.querySelector(
    `.rs-inline-boundary-start[data-rs-uuid="${uuid}"]`,
  );
  const spanEndElement = frameDocument.body.parentElement.querySelector(
    `.rs-inline-boundary-end[data-rs-uuid="${uuid}"]`,
  );

  if (buttonElement && highlightElement && spanStartElement && spanEndElement) {
    return {
      buttonElement,
      highlightElement,
      spanStartElement,
      spanEndElement,
    };
  }

  return null;
};

export default findInlineUserContent;
